<template>
  <div>
    <div slot="title">
      <h2>Nombramientos</h2>
    </div>
    <div slot="main">
      <div class="container-fluid">
        <div class="row">
          <div class="form-group-h col-3">
            <input
              v-model="busqueda"
              class="form-control"
              type="text"
              placeholder="Buscar persona"
            />
          </div>
          <div class="form-group d-flex align-items-center col-3">
            <button
              type="button"
              v-on:click="BuscarPersonas()"
              class="btn btn-primary"
            >
              Buscar
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-12"><hr/></div>
        </div>
        <!-- RESULTADOS DE BÚSQUEDA POR NOMBRE DE PERSONA -->        
        <div class="row">
          <div class="col-12">
            <h4>Personas encontradas</h4>
          </div>
          <div class="col-12 table-responsive">
            <table
              class="table  table-striped table-light table-hover"
              id="tabla_ResultadoPersonasEncontradas"
              data-toggle="table"
              data-pagination="true"
              data-page-size="5"
              data-search="true"
            >
              <thead class="thead-dark">
                <tr>
                  <th data-field="PersonaId" data-sortable="true">
                    Persona Id
                  </th>
                  <th data-field="Nombre" data-sortable="true">
                    Nombre
                  </th>
                  <th data-field="ApellidoPaterno" data-sortable="true">
                    Apellido Paterno
                  </th>
                  <th data-field="ApellidoMaterno" data-sortable="true">
                    Apellido Materno
                  </th>
                  <th
                    data-events="operateEvents"
                    :data-formatter="this.operateFormatter()"
                  >
                    Acciones
                  </th>
                </tr>
              </thead>
            </table>
          </div>
        </div> 
        <hr>       
        <div class="row">
          <div class="col-12">
            <h4>Listado de Nombramientos</h4>
          </div>          
          <div class="col-12 table-responsive">
            <table
              class="table  table-striped table-light table-hover acciones"
              id="tabla_Nombramientos"
              data-toggle="table"
              data-pagination="true"
              data-page-size="10"
              data-search="true"
            >
              <thead class="thead-dark">
                <tr>
                  <th data-field="NombramientoId" data-sortable="true">
                    Nombramiento
                  </th>
                  <th data-field="PersonaNombrada.Nombre" data-sortable="true">
                    Nombre
                  </th>
                  <th
                    data-field="PersonaNombrada.ApellidoPaterno"
                    data-sortable="true"
                  >
                    Apellido Paterno
                  </th>
                  <th
                    data-field="PersonaNombrada.ApellidoMaterno"
                    data-sortable="true"
                  >
                    Apellido Materno
                  </th>
                  <th data-field="FechaInicial" data-sortable="true">
                    Fecha Inicial
                  </th>
                  <th data-field="FechaFinal" data-sortable="true">
                    Fecha Final
                  </th>
                  <th
                    data-field="PersonaSustituida.NombreCompleto"
                    data-sortable="true"
                  >
                    Persona a quién cubre
                  </th>
                  <th
                    data-field="SeEntregoOficioDescriptivo"
                    data-sortable="true"
                  >
                    Se entrgó oficio
                  </th>
                  <th
                    data-events="operateEvents"
                    :data-formatter="this.operateFormatterNombramientos()"
                  >
                    Acciones
                  </th>
                </tr>
              </thead>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="col-12"><hr /></div>
        </div>
        <div class="row">
          <div class="col-12">
            <div slot="title">
              <h2>Buscar nombramientos por fecha</h2>
            </div>          
          </div>     

        
          <div class="form-group-h col-6">
            <label>Fecha Inicial del Nombramiento</label>
            <input
              v-model="fechaInicialPeriodoNombramientos"
              class="form-control"
              type="date"
              placeholder="Fecha Inicial"
            />            
          </div>
          <div class="form-group-h col-6">
            <label>Fecha Final del Nombramiento</label>
            <input
              v-model="fechaFinalPeriodoNombramiento"
              class="form-control"
              type="date"
              placeholder="Fecha Final"
            />
          </div>
          <div class="form-group d-flex align-items-center col-3">
          <button
              type="button"
              v-on:click="BuscarNombramientosPorPeriodoDeFechas()"
              class="btn btn-primary"
            >
              Buscar
            </button>
          </div>
        


          <div class="col-12 table-responsive">
            
            <table
              class="table  table-striped table-light table-hover acciones"
              id="tabla_NombramientosPorFecha"
              data-toggle="table"
              data-pagination="true"
              data-page-size="10"
              data-search="true"
            >
              <thead class="thead-dark">
                <tr>
                  <th data-field="NombramientoId" data-sortable="true">
                    Nombramiento ID
                  </th>
                  <th data-field="PersonaNombrada.Nombre" data-sortable="true">
                    Nombre
                  </th>
                  <th data-field="PersonaNombrada.ApellidoPaterno" data-sortable="true">
                    Apellido Paterno
                  </th>
                  <th data-field="PersonaNombrada.ApellidoMaterno" data-sortable="true">
                    Apellido Materno
                  </th>
                  <th
                    data-field="FechaFinalEtiqueta"
                    data-sortable="true"
                  >
                    Fecha Final
                  </th>
                  <th data-field="FechaInicialEtiqueta" data-sortable="true">
                    Fecha Inicial
                  </th>                  
                  <th
                    data-field="FechaDeRegistro"
                    data-sortable="true"
                  >
                    Fecha de Registro
                  </th>                  
                  
                </tr>
              </thead>
            </table>
          </div>
        </div>

        <!-- MODAL DE CONFIRMACIÓN -->
        <div
          class="modal fade"
          id="modalEstatusNombramiento"
          tabindex="-1"
          role="dialog"
          aria-labelledby="etiquetaDelModal"
          aria-hidden="true"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="tituloModalConfirmacion">
                  ¡Atención!
                </h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-12">
                    {{ cuerpoDelModal }}
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  id="botonModalConfirmacion"
                  @click="ActualizarEstadoDeDocumento"
                  data-dismiss="modal"
                >
                  Aceptar
                </button>
                <!-- @click="guardarFechaReagendamiento" -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import catalogos from "@/../static/js/catalogos";
import comun from "@/../static/js/comun";
import enumeraciones from "@/../static/js/enumeraciones";
import api from "@/../static/js/api";
import axios from "axios";
import Vue from "vue";
import store from "@/store/index";

export default {
  data() {
    return {
      enumeraciones,
      personasEncontradas: [],
      nombramientosEncontrados: [],
      busqueda: null,
      mostrarMotivo: false,
      cuerpoDelModal: "",
      estatusActualDelOficio: null,
      nombramientoIdSeleccionado: null,
      filaSeleccionada: null,
      fechaInicialPeriodoNombramientos: null,
      fechaFinalPeriodoNombramiento: null,
      nombramientosPorFecha: null,
      rutaNombramiento: null
    };
  },
  components: {    
  },
  mounted() {
    this.IniciarEventosDeLasAcciones();
    this.LlenarTablaPersonasEncontradas();
  },
  methods: {
    ActualizarEstadoDeDocumento: function() {
      comun.SeEstaCargandoInformacion(true);
      let peticion = {
        NombramientoId: this.nombramientoIdSeleccionado
      };
      
      axios
        .post(
          api.conexion + api.SIAP.funcion.CambiarEstatusDeEntregaNombramiento,
          peticion,
          comun.CrearElHeaderDeAutorizacion(
            this.$store.state.Login_AutorizacionOriginal
          )
        )
        .then(response => {
          if (response.data.SiHayError == false) {
            
            comun.mensajeDeAlerta(response.data.Satisfactorio, null, null);
            
            var $tabla_Nombramientos = $("#tabla_Nombramientos");
            $tabla_Nombramientos.bootstrapTable('updateCell', {
              index: this.filaSeleccionada,
              field: 'SeEntregoOficioDescriptivo', 
              value: response.data.SeEntregoOficioDescriptivo}
            )
            
          } else {
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
          }
          comun.SeEstaCargandoInformacion(false);
        })
        .catch(e => {
          console.error(e);
          comun.mensajeDeAlerta(
            comun.mensajeDeError(enumeraciones.error.E500),
            null,
            null
          );
          comun.SeEstaCargandoInformacion(false);
        });
    },
    pedirConfirmacion: function(row, index) {      
      this.filaSeleccionada = index;
      this.nombramientoIdSeleccionado = row.NombramientoId;
      
      this.estatusActualDelOficio =
        row.SeEntregoOficioDescriptivo != "Entregado" ? "entregado" : "no entregado";
      this.cuerpoDelModal =
        "¿Desea marcar cómo " + this.estatusActualDelOficio + " el documento?";

      $("#modalEstatusNombramiento").modal();
    },

     

    ///Inicia los eventos que tendran los iconos de las acciones
    IniciarEventosDeLasAcciones() {
      // (e, value, row, index)
      window.operateEvents = {
        "click .cargar-nombramientos": (e, val, row, index) => {
          this.BuscarNombramientosPorPersona(row.PersonaId);
          //this.cargarNombramientos(row.PersonasId);
        },
        // "click .editar-nombramiento": (e, val, row, index) => {
        //   console.log("Se edita el interinato");
        //   // this.$router.push({
        //   //   name: "Nombramientos",
        //   //   params: { propNombramientoId: row.NombramientoId }
        //   // });
        // },
        // "click .descargar-nombramiento": (e, val, row, index) => {
        //   console.log("Se descaga el interinato");
        // },
        // "click .marcar-terminado-nombramiento": (e, val, row, index) => {
        //   console.log(row);
        //   this.pedirConfirmacion(row, index);
        // },
        "click .generar-nombramiento": (e, val, row, index) => {   
              
          this.GenerarNombramiento(row);      
        }        
      };
    },
    operateFormatter: (value, row, index) => {
      return [
        '<a class="cargar-nombramientos" href="javascript:void(0)" title="Cargar Nombramientos">',
        '<i class="far fa-file-alt"></i>',
        "</a>"
      ].join("");
    },
    operateFormatterNombramientos: (value, row, index) => {
      return [
        // '<a style="margin-right:5px;" class="editar-nombramiento" href="javascript:void(0)" title="Editar Nombramiento">',
        // '<i class="fas fa-edit"></i>',
        // "</a>",
        '<a style="margin-right:5px;" class="generar-nombramiento" href="javascript:void(0)" title="Generar Nombramiento">',
        '<i class="far fa-file-word"></i>',
        "</a>",
        // '<a style="margin-right:5px;" class="descargar-nombramiento" href="javascript:void(0)" title="Descargar Digitalización">',
        // '<i class="fas fa-download"></i>',
        // "</a>",
        // '<a style="margin-right:5px;" class="marcar-terminado-nombramiento" href="javascript:void(0)" title="Marcar de entregado">',
        // '<i class="fas fa-check"></i>',
        // "</a>"
      ].join("");
    },
    GenerarNombramiento(nombramiento){
      
      comun.SeEstaCargandoInformacion(true);
      let peticion = {
        Nombramiento: nombramiento
      };
      axios
        .post(
          api.conexion + api.SIAP.funcion.GenerarPlantillaDeNombramiento,
          peticion,
          comun.CrearElHeaderDeAutorizacion(
            this.$store.state.Login_AutorizacionOriginal
          )
        )
        .then(response => {
          debugger
          if (response.data.SiHayError == false) {
            console.log(response.data);
            this.personasEncontradas = response.data.Personas;
            this.rutaNombramiento = response.data.rutaArchivo;            
            this.DescargarNombramiento();
            //this.LlenarTablaPersonasEncontradas();
            
            
            // Le asigna el valor de la ruta del nombramiento que se acaba de guardar en el ftp
            
          } else {
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
          }
          comun.SeEstaCargandoInformacion(false);
        })
        .catch(e => {
          console.error(e);
          comun.mensajeDeAlerta(
            comun.mensajeDeError(enumeraciones.error.E500),
            null,
            null
          );
          comun.SeEstaCargandoInformacion(false);
        });
    },
    DescargarNombramiento: function () {
      debugger
        if (this.rutaNombramiento != null) {
          var a = document.createElement("a");
          document.body.appendChild(a);
           a.href = `${api.conexion}${api.Comun.funcion.DescargarArchivo}?rutaDelArchivo=${this.rutaNombramiento}`
          a.click();
        }
      },
    
    BuscarNombramientosPorPeriodoDeFechas(){
      if( (this.fechaInicialPeriodoNombramientos != "" && this.fechaInicialPeriodoNombramientos != null) 
          &&  (this.fechaFinalPeriodoNombramiento != "" && this.fechaFinalPeriodoNombramiento != null) ){
              // REALIZA LA PETICIÓN PARA BUSCAR FILTRANDO POR FECHAS LOS NOMBRAMIENTOS

              comun.SeEstaCargandoInformacion(true);
              

               let peticion = {
        FechaInicial: this.fechaInicialPeriodoNombramientos,
        FechaFinal: this.fechaFinalPeriodoNombramiento
      };
              
               axios
        .post(
          api.conexion + api.SIAP.funcion.NombramientosPorFeecha,
          peticion,
          comun.CrearElHeaderDeAutorizacion(
            this.$store.state.Login_AutorizacionOriginal
          )
        )
        .then(response => {
          if (response.data.SiHayError == false) {
            this.nombramientosPorFecha = response.data.Nombramientos;
            this.LlenarTablaNombramientosPorFecha();
          } else {
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
          }
          comun.SeEstaCargandoInformacion(false);
        })
        .catch(e => {
          console.error(e);
          comun.mensajeDeAlerta(
            comun.mensajeDeError(enumeraciones.error.E500),
            null,
            null
          );
          comun.SeEstaCargandoInformacion(false);
        });
      }
      else 
      //if(this.numeroDeOficio == null || this.numeroDeOficio == undefined)
      {
        comun.mensajeDeAlerta("Debe de seleccionar un periodo para buscar nombramientos por fecha.", null, null);
        return false;
      }
    },
    LlenarTablaNombramientosPorFecha(){
      var $tabla_NombramientosPorFecha = $("#tabla_NombramientosPorFecha");
      $tabla_NombramientosPorFecha.bootstrapTable({ data: this.nombramientosPorFecha });
      $tabla_NombramientosPorFecha.bootstrapTable("load", this.nombramientosPorFecha);
    },
    BuscarPersonas() {
      if(this.busqueda != "" || this.busqueda != null){
        comun.SeEstaCargandoInformacion(true);
      let peticion = {
        busqueda: this.busqueda
      };
      axios
        .post(
          api.conexion + api.SIAP.funcion.ObtenerPersonas,
          peticion,
          comun.CrearElHeaderDeAutorizacion(
            this.$store.state.Login_AutorizacionOriginal
          )
        )
        .then(response => {
          if (response.data.SiHayError == false) {
            this.personasEncontradas = response.data.Personas;
            this.LlenarTablaPersonasEncontradas();
          } else {
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
          }
          comun.SeEstaCargandoInformacion(false);
        })
        .catch(e => {
          console.error(e);
          comun.mensajeDeAlerta(
            comun.mensajeDeError(enumeraciones.error.E500),
            null,
            null
          );
          comun.SeEstaCargandoInformacion(false);
        });
   
      }
       },
    BuscarNombramientosPorPersona(personaId) {
      
      comun.SeEstaCargandoInformacion(true);
      let peticion = {
        personaId: personaId
      };
      axios
        .post(
          api.conexion + api.SIAP.funcion.ObtenerNombramientosPorPersona,
          peticion,
          comun.CrearElHeaderDeAutorizacion(
            this.$store.state.Login_AutorizacionOriginal
          )
        )
        .then(response => {
          if (response.data.SiHayError == false) {
            this.nombramientosEncontrados = response.data.Nombramientos;
            this.LlenarTablaNombramientosEncontrados();
          } else {
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
          }
          comun.SeEstaCargandoInformacion(false);
        })
        .catch(e => {
          console.error(e);
          comun.mensajeDeAlerta(
            comun.mensajeDeError(enumeraciones.error.E500),
            null,
            null
          );
          comun.SeEstaCargandoInformacion(false);
        });
    },
    LlenarTablaPersonasEncontradas() {
      var $tabla_Personas = $("#tabla_ResultadoPersonasEncontradas");
      $tabla_Personas.bootstrapTable({ data: this.personasEncontradas });
      $tabla_Personas.bootstrapTable("load", this.personasEncontradas);
    },
    LlenarTablaNombramientosEncontrados() {
      var $tabla_Nombramientos = $("#tabla_Nombramientos");
      $tabla_Nombramientos.bootstrapTable({
        data: this.nombramientosEncontrados
      });
      $tabla_Nombramientos.bootstrapTable(
        "load",
        this.nombramientosEncontrados
      );
    },

    // editarUsuario: function(curpUsuario) {
    //   //Redirigeal usuario a la pantalla de editarusuario mandando como parametro el id de persona a editar
    //   this.$router.push({
    //     name: "AltaDeUsuario",
    //     params: { propCurp: curpUsuario }
    //   });
    // }
  }
};
</script>

<style scoped>
/* Se requiere para que el color del texto de la tabla sea negro */
table {
  color: #343a40 !important;
}

</style>



// WEBPACK FOOTER //
// src/components/SIAP/Nombramientos/BuscarNombramientos.vue